﻿/// <reference path="../../../../Scripts/TypeScript/angularjs/angular.d.ts"/>
/// <reference path="../../TaskOverviewService.ts"/>

namespace Umbrella.TaskHandling {
    angular.module('TaskHandling').config([
        '$stateProvider',
        $stateProvider => {
            $stateProvider.state(
                'dashboard.tasks.overview.details.contactmoments',
                {
                    url: '/contactmomenten',
                    reloadOnSearch: false,
                    data: {
                        pageTitle: 'Contactmomenten',
                        authorize: ps => ps.viewTask || ps.editTask
                    },
                    views: {
                        tabcontent: {
                            template:
                                '<task-contact-moments state="state$ | async:this"></task-contact-moments>',
                            controller: Umbrella.createComponentRouteController<
                                Overview.State,
                                TaskContactMomentsComponentState
                            >('TaskOverviewStore', s => ({
                                task: s && s.selectedTask,
                                linkedTasks: s && s.linkedTasks
                            }))
                        }
                    }
                }
            );
        }
    ]);
}
